class CartDrawerCustom extends HTMLElement {
    constructor() {
        super();

        if (this.querySelector('.add-gift')) {
            this.querySelector('.add-gift').addEventListener('click', this.addProduct.bind(this));
        }

        if (document.querySelector('.cart-drawer-checkbox.delete_product')) {
            document.querySelector('.cart-drawer-checkbox.delete_product').querySelector('drawer-remove-button').click();
        }
    }

    addProduct() {
        this.selection = [{
            id: Number(this.querySelector('.add-gift').getAttribute('data-id')),
            quantity: 1
        }
        ];

        let items = [];

        Object.keys(this.selection).forEach((key) => {
            if (this.selection[key]) {
                items.push({
                    id: this.selection[key]['id'],
                    quantity: 1,
                    properties: {
                        _bundle: true,
                    },
                });
            }
        });

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: items,
                sections: Shopify.getSectionsToRender().map(
                    (section) => section.section
                ),
                sections_url: window.location.pathname,
            }),
        })
            .then((response) => response.text())
            .then((data) => {
                const parsedState = JSON.parse(data);
                Shopify.getSectionsToRender().forEach((section) => {
                    const elementToReplace =
                        document
                            .getElementById(section.id)
                            .querySelector(section.selector) ||
                        document.getElementById(section.id);

                    console.log('elementToReplace', elementToReplace);
                    console.log('parsedState', parsedState);

                    elementToReplace.innerHTML = Shopify.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector
                    );
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
}

customElements.define('cart-drawer-custom', CartDrawerCustom);